import { render } from "./Legal.vue?vue&type=template&id=346df567"
const script = {}

import "./Legal.vue?vue&type=style&index=0&id=346df567&lang=css"

import exportComponent from "/Users/vhstrejo/Sites/todo-inclusion/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__